import React, { useState, Dispatch, SetStateAction } from 'react';
import { Modal, Spinner, Button } from 'react-bootstrap';

interface Props {
    shouldShow: boolean;
    onHideModal: () => void;
    handleSubmit: (setSubmitting: Dispatch<SetStateAction<boolean>>) => void;
    title: string;
    message ?: string;
    btnText: string;
    btnVariant?: string;
    error?: string;
}

const ConfirmationModal = ({
    shouldShow,
    onHideModal,
    handleSubmit,
    title,
    message,
    btnText,
    btnVariant,
    error,
}: Props) => {
    const [submitting, setSubmitting] = useState(false);

    return (
        <Modal show={shouldShow} onHide={onHideModal} centered>
            <Modal.Header closeButton onHide={onHideModal}>
                <Modal.Title as="h5">{title}</Modal.Title>
            </Modal.Header>
            {(error || message) && (
                <Modal.Body>
                    <p>{message}</p>
                    <p>{error}</p>
                </Modal.Body>
            )}
            <Modal.Footer>
                <Button
                    onClick={onHideModal}
                    variant="outline-primary"
                    data-cy="confirmation-modal-cancel"
                >
                    Cancel
                </Button>
                <Button
                    variant={btnVariant ? btnVariant : 'success'}
                    onClick={() => handleSubmit(setSubmitting)}
                    data-cy="confirmation-modal-submit"
                >
                    {submitting ? (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            data-cy="confirmation-modal-spinner"
                        />
                    ) : (
                        btnText
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
